// removed by extract-text-webpack-plugin
module.exports = {"wrap":"src-components-Common-Correction-index-wrap-3myO3","pop":"src-components-Common-Correction-index-pop-3lTLQ","textarea":"src-components-Common-Correction-index-textarea-3pzsY","submitContent":"src-components-Common-Correction-index-submitContent-3Kyhg","submitBtn":"src-components-Common-Correction-index-submitBtn-2kq7n","notSubmit":"src-components-Common-Correction-index-notSubmit-2hpHW","errorTips":"src-components-Common-Correction-index-errorTips-1vhNi"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Common/Correction/index.css
 ** module id = 260
 ** module chunks = 0
 **/